import * as React from 'react'
import { useTranslation } from 'react-i18next'
import '../css/appsTable.css'
import '../css/appsTableConfidence.css'

interface App {
  iconUrl: string
  name: string
  category: string
  averageUserRating: number
  confidence: number
  isDefault: boolean
}

interface AppsTableProps {
  data: App[]
  addToIndex?: number
}

const createdKeyframes = {}

export const AppsTable = (props: AppsTableProps) => {
  const { t } = useTranslation('appsTable')

  function getStatusMessage(percents) {
    if (percents <= 35) return t('Low Confidence')
    if (percents <= 60) return t('Moderate Confidence')
    if (percents <= 80) return t('Moderate-High Confidence')
    return t('High Confidence')
  }

  function createKeyframes(animationName, confidencePercents) {
    if (createdKeyframes[confidencePercents]) return
    
    const filledBarKeyframes = `@keyframes ${animationName} {
            from {width: 0%}
            to {width: ${confidencePercents + '%'}}
          }`
    const style = document.createElement('style')
    style.innerHTML = filledBarKeyframes
    document.head.appendChild(style)
    createdKeyframes[confidencePercents] = true
  }

  const renderConfidence = (confidence: number, isDefault: boolean) => {
    const confidencePercents = Math.floor(confidence * 100)
    const filledDotsCount = Math.floor(confidencePercents / 25) + 1

    const animationName = `filled-bar-${confidencePercents}`
    createKeyframes(animationName, confidencePercents)

    const filledBarStyles = {
      animationName: animationName,
      animationTimingFunction: 'linear',
      animationDuration: isDefault ? '0s' : confidence + 's',
      animationDelay: '0.0s',
      animationIterationCount: 1,
      animationFillMode: 'forwards'
    }

    return (<>
      <div className="apps-table-confidence__progressbar">
        <div className="apps-table-confidence__bar" />
        <div className="apps-table-confidence__filled-bar" style={filledBarStyles} />
        <span className={`apps-table-confidence__dot ${filledDotsCount >= 1 ? 'apps-table-confidence__dot_filled' : ''}`} />
        <span className={`apps-table-confidence__dot ${filledDotsCount >= 2 ? 'apps-table-confidence__dot_filled' : ''}`} />
        <span className={`apps-table-confidence__dot ${filledDotsCount >= 3 ? 'apps-table-confidence__dot_filled' : ''}`} />
        <span className={`apps-table-confidence__dot ${filledDotsCount >= 4 ? 'apps-table-confidence__dot_filled' : ''}`} />
        <span className={`apps-table-confidence__dot ${filledDotsCount >= 5 ? 'apps-table-confidence__dot_filled' : ''}`} />
      </div>
      <span className="apps-table-confidence__percents">{confidencePercents}%</span>
      <span className="apps-table-confidence__info-hover">i</span>
      <div className="apps-table-confidence__info-box">
        <div className="apps-table-conficence__triangle" />
        <p className="apps-table-confidence__info-title">{t('Confidence Level')}</p>
        <p className="apps-table-confidence__info-status">{confidencePercents}% - {getStatusMessage(confidencePercents)}</p>
        <p className="apps-table-confidence__info-paragraph">{t('As context')}</p>
        <p>{t('Confidence is effected')}</p>
      </div>
    </>)
  }

  const renderApps = (isMobile = false) => props.data.map((app, index) => {
    const appNumber = index + (props.addToIndex ? props.addToIndex : 1)

    return isMobile ? (
      <div
        className="apps-table__item"
        key={'app-' + appNumber + app.iconUrl}
      >
        <div className="apps-table__item-number">{appNumber + '.'}</div>
        <div className="apps-table__item-main">
          <div className="apps-table__item-main-content">
            <img src={app.iconUrl} />
            <span className="apps-table__title">{app.name}</span>
          </div>
          <div className="apps-table__item-other apps-table-confidence">
            {renderConfidence(app.confidence, app.isDefault)}
          </div>
        </div>
      </div>
    ) : (
        <tr key={'app-' + appNumber + app.iconUrl}>
          <td>{appNumber + '.'}</td>
          <td>
            <img src={app.iconUrl} />
            <span className="apps-table__title">{app.name}</span>
          </td>
          <td className="apps-table-confidence" style={{ width: '40%', textOverflow: 'clip' }}>
            {renderConfidence(app.confidence, app.isDefault)}
          </td>
        </tr>
      )
  })

  const isDefault = props.data[0] && props.data[0].isDefault
  return (
    <>
      <table className={`apps-table apps-table--desktop ${isDefault ? 'apps-table--default' : ''}`}>
        <thead>
          <tr>
            <th>{t('Number')}</th>
            <th>{t('App name')}</th>
            <th>{t('Confidence')}</th>
          </tr>
        </thead>
        <tbody>
          {renderApps()}
        </tbody>
      </table>
      <div className={`apps-table apps-table--mobile ${isDefault ? 'apps-table--default' : ''}`}>
        {renderApps(true)}
      </div>
    </>
  )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/appsTable.tsx